import React from "react";
import {useTranslation} from "react-i18next";

import IconContainer from "../shared/IconContainer";
import RelatedContent from "./RelatedContent";
import * as pageStyles from "../../styles/internal-page/internal-page.module.scss";

const OpenedRelatedContents = React.memo(function OpenedRelatedContents({
  related_contents,
  handleClickBack
}) {
  const { t } = useTranslation();
  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 1250) {
        handleClickBack();
      }
    }
    window.addEventListener('resize', handleResize)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      <div className={pageStyles.rootContainer}>
        <div className={pageStyles.rootItem}>
          <button
            className={pageStyles.marginBetweenBlocsRelatedContent}
            onClick={() => handleClickBack()}
          >
            <IconContainer icon="ARROW_LEFT_NORMAL" color="BLACK" size={15} />
            <p className={pageStyles.backButton}>
              {t("back.label")}
            </p>
          </button>
          {related_contents?.map((elem, index) => {
            return <RelatedContent elem={elem.content[0]} key={index} />;
          })}
        </div>
      </div>
    </>
  );
});

export default OpenedRelatedContents;
